module.exports = __webpack_public_path__ + "img/portrait-sara-neutral.1f12cdca.jpg";